import "core-js/modules/web.dom-collections.iterator.js";
import { SingleEventHandler } from '@edreamsodigeo/frontend-core';
const handledErrorCodes = new Set(['ERR-01']);
const isNotHandledError = error => {
  var _error$extensions;
  return !handledErrorCodes.has(error === null || error === void 0 || (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.code);
};
const createHandler = Odigeo => {
  const eventHandler = SingleEventHandler();
  return {
    dispatchRenderError(error, message) {
      Odigeo.trigger('frontend-shell:javascript-error', error, message);
    },
    dispatchFrontendAPIError(errors) {
      const unhandledErrors = errors.filter(isNotHandledError);
      if (unhandledErrors.length > 0) {
        Odigeo.trigger('frontend-shell:frontend-api-error', unhandledErrors);
      }
    },
    restore: eventHandler.trigger,
    onRestore: eventHandler.listen,
    stopOnRestore: eventHandler.stopListening
  };
};
export default createHandler;